export const STEP_WEIGHT = 0.05;
